import React from "react";
import { Badge } from "@/components/ui/badge";
import { Search } from "lucide-react";
import DashboardWidget from "@/components/DashboardWidget";

interface AnalyticsStats {
  searchKeywords: Array<{ keyword: string; count: number }>;
}

interface SearchKeywordsWidgetProps {
  stats: AnalyticsStats | null;
}

export const SearchKeywordsWidget: React.FC<SearchKeywordsWidgetProps> = ({
  stats,
}) => {
  return (
    <DashboardWidget
      id="search-keywords"
      title="Google Search Keywords"
      headerActions={<Search className="h-5 w-5" />}
    >
      {stats?.searchKeywords?.length ? (
        <div className="space-y-3">
          {stats.searchKeywords.slice(0, 6).map((item, index) => (
            <div
              key={item.keyword}
              className="p-3 border rounded-lg bg-gradient-to-r from-green-50 to-blue-50"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="font-semibold text-gray-900">
                  #{index + 1}
                </span>
                <Badge variant="secondary">{item.count} searches</Badge>
              </div>
              <p className="text-sm text-gray-700">"{item.keyword}"</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-4">
          <Search className="h-8 w-8 text-gray-300 mx-auto mb-3" />
          <p className="text-gray-500 text-sm">
            No search keyword data available yet
          </p>
          <p className="text-xs text-gray-400">
            Keywords will appear when users visit from Google search
          </p>
        </div>
      )}
    </DashboardWidget>
  );
};

export default SearchKeywordsWidget;
